// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__17HMx","label":"Radio_label__3IOQ1","checkMark":"Radio_checkMark__3m9L_","disabled":"Radio_disabled__2AeQy"};